const BMYPAGE_URL = process.env.VUE_APP_BMYPAGE_URL;
const VUE_APP_WP_URL = process.env.VUE_APP_WP_URL;
export const url = {
  // サービスガイド
  LINK_YMT_SERVICE_GUIDE: BMYPAGE_URL + "/WPTWeb.html",
  // サービス詳細
  LINK_YMT_SERVICE_DETAIL: BMYPAGE_URL + "/WPTWeb.html",
  // ヤマトビジネスメンバーズ 利用規約
  LINK_YMT_MEMBERS_TERMS_OF_SERVICE: BMYPAGE_URL + "/riyoukiyaku.html",
  // 個人情報のお取り扱いについて
  LINK_YMT_PRIVACY: "http://www.kuronekoyamato.co.jp/ytc/privacy/",
  // 各種約款
  LINK_YMT_AGREEMENT: "http://www.kuronekoyamato.co.jp/ytc/agreement/",
  // ホームページ
  LINK_YMT_HOME: "http://www.kuronekoyamato.co.jp/",
  // YBMログイン
  LINK_YMT_YBM_LOGIN:
    BMYPAGE_URL +
    "/servlet/jp.co.kuronekoyamato.wur.hmp.servlet.user.HMPLGI0010JspServlet",
  // YBMメインメニュー
  LINK_YMT_YBM_MAIN_MENU: BMYPAGE_URL + "/ME0001.htm",
  // 国際宅急便・国際クール宅急便のPDFアイコンマークのリンク
  LINK_YMT_OVERSEA_MARK_LINK: VUE_APP_WP_URL + "/wp_manual_00.pdf",
  // 国別ガイド
  LINK_YMT_COUNTRYS_GUIDE: "http://date.kuronekoyamato.co.jp/date/Main?LINK=WT",
  // サービスセンター一覧
  LINK_YMT_SERVICE_LIST:
    "http://www.kuronekoyamato.co.jp/ytc/center/servicecenter_list.html",
  // お問い合わせフォーム
  LINK_YMT_CONTACTFORM:
    "https://business.kuronekoyamato.co.jp/contact/form/?prevpage=intl_transport",
  LINK_KOKUSAITAKKYUBIN:
    "http://www.kuronekoyamato.co.jp/ytc/agreement/pdf/y_13_kokusaitakkyubin.pdf?20030301",
  // YBMお問い合わせページ
  LINK_YBM_CONTACTPAGE:
    "https://b-faq.kuronekoyamato.co.jp/app/ask?sa_parameter=system_error&utm_source=ybm&utm_medium=referral&utm_campaign=ybm_error_inquiry",
  // ヤマト運輸ホームページの禁制品確認画面
  LINK_PROHIBITED_ITEM_CONFIRM_HOME:
    "http://www.kuronekoyamato.co.jp/ytc/customer/send/services/oversea/caution.html",
  // 国に対応した禁制品確認画面
  LINK_PROHIBITED_ITEM_CONFIRM_COUNTRY:
    "http://date.kuronekoyamato.co.jp/date/KokusaiTakkyubin?ACTID=J_RKWTJS0020&SEARCH_ID=01&LAND_CD=",
  // 荷物お問い合わせシステム
  LINK_YMT_TRACKING_SHIPPMENT:
    "https://toi.kuronekoyamato.co.jp/cgi-bin/tneko?type=1&no01={0}&id={1}",
  //link to adobe
  LINK_ADOBE: "https://get.adobe.com/jp/reader/",
  //品目の注意事項
  LINK_ITEM_PRECAUTIONS: "https://faq-biz.kuronekoyamato.co.jp/app/answers/detail/a_id/10068",
  //荷主管理番号入力方法
  LINK_REFERENCE_NO_INPUT_METHOD: "https://b-faq.kuronekoyamato.co.jp/app/answers/detail/a_id/434",

  //'利用規約画面
  LINK_YMT_TERMS_OF_SERVICE: BMYPAGE_URL + "/WPTWeb_rule.html",

  // EU付加価値税 (VAT) 規則の説明
  LINK_YMT_VAT_SELECTION_DETAIL: VUE_APP_WP_URL + "/wp_VatExplanation.pdf",

  // chatbot
  LINK_CHAT_BOT: process.env.VUE_APP_LINK_CHAT_BOT,

  // 送り状・インボイスの貼付方法
  LINK_WP_MANUAL: VUE_APP_WP_URL + "/wp_manual_18.pdf",
  // データ交換規約
  LINK_YMT_DATA_EXCHANGE_TERMS: VUE_APP_WP_URL + "/wp_dataExchange.pdf",
  // データ交換規約(各種マスタ)
  LINK_YMT_MASTER_DATA_EXCHANGE_TERMS:
    VUE_APP_WP_URL + "/wp_masterDataExchange.pdf",
  // 国コード
  LINK_YMT_COUNTRY_CD: VUE_APP_WP_URL + "/wp_countryCode.pdf",
  // 州コード
  LINK_YMT_STATE_CD: VUE_APP_WP_URL + "/wp_stateCode.pdf",
  // Tax ID
  LINK_YMT_TAX_ID: VUE_APP_WP_URL + "/wp_taxId.pdf",
  // 基本レイアウトテンプレート
  LINK_YMT_BASIC_LAYOUT_TEMPLATE: VUE_APP_WP_URL + "/wp_template.xlsx",
  // 基本レイアウトテンプレート(お届け先)
  LINK_YMT_BASIC_LAYOUT_CONSIGNEES_TEMPLATE:
    VUE_APP_WP_URL + "/wp_consigneesTemplate.xlsx",
  // 基本レイアウトテンプレート(ご依頼主)
  LINK_YMT_BASIC_LAYOUT_SHIPPERS_TEMPLATE:
    VUE_APP_WP_URL + "/wp_shippersTemplate.xlsx",
  // 基本レイアウトテンプレート(品目)
  LINK_YMT_BASIC_LAYOUT_ITEM_TEMPLATE: VUE_APP_WP_URL + "/wp_itemTemplate.xlsx"
};

export default url;
